import { HSDetails } from './HSDetails'
import ViewEditHSContextProvider from './ViewEditHS/Providers/ViewEditHSContextProvider'
import MyOrganizationCommunityPopupProvider from 'features/MyCommunity/MyOrganizationCommunity/Providers/MyOrganizationCommunityPopupProvider'

export const HSDetailsContainer = () => {
  return (
    <MyOrganizationCommunityPopupProvider>
      <ViewEditHSContextProvider>
        <HSDetails />
      </ViewEditHSContextProvider>
    </MyOrganizationCommunityPopupProvider>
  )
}
